import Form from '../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../utils/analytics-helper';

export default class RegisterValidateOTPView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.register-validate-otp-view');
        this.correlationText = this.el.querySelector('.correlationText');
        this.otpInput = this.el.querySelector('input[name="otp"]');
        this.otpIdInput = this.el.querySelector('input[name="otpId"]');
        this.correlationInput = this.el.querySelector('input[name="correlation"]');
        this.emailInput = this.el.querySelector('input[name="email"]');
        this.form = new Form(this.parent.el.querySelector('.register-validate-otp-form'), {
            onSubmit: this.onSubmit.bind(this),
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),            
        });
        this.resendOtp = this.el.querySelector('.resend-otp');
        this.bind();
    }

    bind() {
        this.resendOtp.addEventListener('click', (e) => {
            e.preventDefault();
            this.parent.show({ view: 'register-validate-otp'});
            this.parent.views['login'].registerSendOTP.submit({
                onSuccess: () => {
                    this.parent.show({ view: 'register-validate-otp', message: this.form.el.dataset.resendOtpMessage, messageType: 'success'});
                }
            });
       });
    }

    onSubmit() {
        this.parent.show({ view: 'register-validate-otp'});
    }

    onSuccess(result) {
        if(result.exists) {
            this.parent.show({ view: 'login', message: this.form.el.dataset.accountExistsError });
        } else {
            this.parent.show({ view: 'register' });
        }
        this.analyticsPush();
    }

    onError(result) {
        this.form.showError();
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    populate(data) {
        this.otpInput.value = '';
        this.correlationText.textContent = data.correlation;
        this.otpIdInput.value = data.otpId;
        this.correlationInput.value = data.correlation;
        this.emailInput.value = data.email;
        this.form.hideError();
    }

    back() {
        this.parent.show({ view: 'login', tab: 'register' });
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event:'my_account',
            eventCategory:'my account',
            eventAction:'Registration OTP Submit',
            eventLabel:`${dataLayer[0].productCategory}|My account|Submit|internal|email id submitted|#`,
            actionType:'Registration OTP Submit',
            businessUnit: dataLayer[0].productCategory,
            moduleName:'My account',
            clickText:'Submit',
            clickType:'internal',
            registrationStep:'otp submitted',
            destinationURL:'#'
        });
    }
}
